import { render, staticRenderFns } from "./OrderTableSelection.vue?vue&type=template&id=32f477b9&scoped=true&"
import script from "./OrderTableSelection.vue?vue&type=script&lang=js&"
export * from "./OrderTableSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f477b9",
  null
  
)

export default component.exports